import styled from 'styled-components';

const Content = styled.div`
  color: ${({ theme }) => theme.commons.tooltip.textColor};
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular}
  border-radius: 6px;
  background-color: ${({ theme }) => theme.commons.tooltip.background};
  line-height: 16px;
  position: relative;
  padding: ${({ theme }) => theme.spacing(6)};
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export default Content;
